export const notificationDelay = 3000;

export const notificationPermissions = {
  default: "default",
  granted: "granted",
  denied: "denied",
};
